<!-- Vue 3 wrapper for Bryntum VersionGrid -->

<template>
    <div ref="refElement">

    </div>
</template>

<script>
import { ColumnStore, ExportDialog, Grid, Layout, Location, Mask, Model, ProjectModel, Rectangle, ScrollManager, Scroller, StateProvider, Store, Tool, VersionGrid, VersionGridFeaturesConfigType, Widget } from '@bryntum/schedulerpro';
import { getCurrentInstance, onBeforeUnmount, onMounted, ref, watch, provide } from 'vue';
import useWrapperHelper from './WrapperHelper.js';
import useWrapperHelperVue3 from './WrapperHelperVue3.js';

export default {
    name : 'BryntumVersionGrid',

    props : {

         // Configs only
        adopt                         : { type : [HTMLElement, String], default : undefined },
        align                         : { type : [Object, String], default : undefined },
        allowOver                     : { type : Boolean, default : undefined },
        anchor                        : { type : Boolean, default : undefined },
        anchorToTarget                : { type : Boolean, default : undefined },
        animateRemovingRows           : { type : Boolean, default : undefined },
        ariaDescription               : { type : String, default : undefined },
        ariaLabel                     : { type : String, default : undefined },
        autoClose                     : { type : Boolean, default : undefined },
        autoHeight                    : { type : Boolean, default : undefined },
        autoShow                      : { type : Boolean, default : undefined },
        autoUpdateRecord              : { type : Boolean, default : undefined },
        bbar                          : { type : [Array, Object], default : undefined },
        bodyCls                       : { type : [String, Object], default : undefined },
        bubbleEvents                  : { type : Object, default : undefined },
        callOnFunctions               : { type : Boolean, default : undefined },
        centered                      : { type : Boolean, default : undefined },
        closable                      : { type : Boolean, default : undefined },
        closeAction                   : { type : String, default : undefined },
        collapsed                     : { type : Boolean, default : undefined },
        collapsible                   : { type : [Boolean, Object], default : undefined },
        columns                       : { type : [ColumnStore, Array, Object], default : undefined },
        config                        : { type : Object, default : undefined },
        constrainTo                   : { type : [HTMLElement, Widget, Rectangle], default : undefined },
        contentElementCls             : { type : [String, Object], default : undefined },
        contextMenuTriggerEvent       : { type : String, default : undefined },
        dateFormat                    : { type : String, default : undefined },
        defaultBindProperty           : { type : String, default : undefined },
        defaultFocus                  : { type : Function, default : undefined },
        defaultRegion                 : { type : String, default : undefined },
        defaults                      : { type : Object, default : undefined },
        destroyStore                  : { type : Boolean, default : undefined },
        disableGridRowModelWarning    : { type : Boolean, default : undefined },
        dismissDelay                  : { type : Number, default : undefined },
        dock                          : { type : [String, Object], default : undefined },
        draggable                     : { type : [Boolean, Object], default : undefined },
        enableSticky                  : { type : Boolean, default : undefined },
        enableTextSelection           : { type : Boolean, default : undefined },
        features                      : { type : Object, default : undefined },
        fillLastColumn                : { type : Boolean, default : undefined },
        fixedRowHeight                : { type : Boolean, default : undefined },
        floating                      : { type : Boolean, default : undefined },
        focusOnToFront                : { type : Boolean, default : undefined },
        footer                        : { type : [Object, String], default : undefined },
        forElement                    : { type : HTMLElement, default : undefined },
        forSelector                   : { type : String, default : undefined },
        fullRowRefresh                : { type : Boolean, default : undefined },
        getHtml                       : { type : [Function, String], default : undefined },
        getRowHeight                  : { type : Function, default : undefined },
        header                        : { type : [String, Boolean, Object], default : undefined },
        hideAnimation                 : { type : [Boolean, Object], default : undefined },
        hideDelay                     : { type : Number, default : undefined },
        hideHorizontalScrollbar       : { type : Boolean, default : undefined },
        hideOnDelegateChange          : { type : Boolean, default : undefined },
        hideWhenEmpty                 : { type : Boolean, default : undefined },
        hoverDelay                    : { type : Number, default : undefined },
        htmlCls                       : { type : [String, Object], default : undefined },
        ignoreParentReadOnly          : { type : Boolean, default : undefined },
        itemCls                       : { type : String, default : undefined },
        keyMap                        : { type : Object, default : undefined },
        lazyItems                     : { type : [Object, Array], default : undefined },
        listeners                     : { type : Object, default : undefined },
        loadingMsg                    : { type : String, default : undefined },
        loadMask                      : { type : [String, Object, null], default : undefined },
        loadMaskDefaults              : { type : Object, default : undefined },
        loadMaskError                 : { type : [Object, Mask, Boolean], default : undefined },
        localeClass                   : { type : Function, default : undefined },
        localizable                   : { type : Boolean, default : undefined },
        localizableProperties         : { type : Array, default : undefined },
        maskDefaults                  : { type : Object, default : undefined },
        masked                        : { type : [Boolean, String, Object], default : undefined },
        maximizable                   : { type : Boolean, default : undefined },
        maximized                     : { type : Boolean, default : undefined },
        modal                         : { type : Boolean, default : undefined },
        monitorResize                 : { type : Boolean, default : undefined },
        mouseOffsetX                  : { type : Number, default : undefined },
        mouseOffsetY                  : { type : Number, default : undefined },
        namedItems                    : { type : Object, default : undefined },
        owner                         : { type : Widget, default : undefined },
        plugins                       : { type : Array, default : undefined },
        positioned                    : { type : Boolean, default : undefined },
        preserveFocusOnDatasetChange  : { type : Boolean, default : undefined },
        preserveScrollOnDatasetChange : { type : Boolean, default : undefined },
        preventTooltipOnTouch         : { type : Boolean, default : undefined },
        project                       : { type : ProjectModel, default : undefined },
        relayStoreEvents              : { type : Boolean, default : undefined },
        resizeToFitIncludesHeader     : { type : Boolean, default : undefined },
        responsiveLevels              : { type : Object, default : undefined },
        ripple                        : { type : [Boolean, Object], default : undefined },
        rootElement                   : { type : ShadowRoot, default : undefined },
        scrollAction                  : { type : [String, null], default : undefined },
        scrollerClass                 : { type : Function, default : undefined },
        scrollManager                 : { type : [Object, ScrollManager], default : undefined },
        selectionMode                 : { type : Object, default : undefined },
        showAnimation                 : { type : [Boolean, Object], default : undefined },
        showDirty                     : { type : Boolean, default : undefined },
        showOnClick                   : { type : Boolean, default : undefined },
        showOnHover                   : { type : Boolean, default : undefined },
        showTooltipWhenDisabled       : { type : Boolean, default : undefined },
        stateful                      : { type : [Boolean, Object, Array], default : undefined },
        statefulEvents                : { type : [Object, Array], default : undefined },
        stateId                       : { type : String, default : undefined },
        stateProvider                 : { type : StateProvider, default : undefined },
        strips                        : { type : Object, default : undefined },
        subGridConfigs                : { type : Object, default : undefined },
        syncMask                      : { type : [String, Object, null], default : undefined },
        tab                           : { type : [Boolean, Object], default : undefined },
        tag                           : { type : String, default : undefined },
        tbar                          : { type : [Array, Object], default : undefined },
        textAlign                     : { type : String, default : undefined },
        textContent                   : { type : Boolean, default : undefined },
        trackMouse                    : { type : Boolean, default : undefined },
        trapFocus                     : { type : Boolean, default : undefined },
        ui                            : { type : [String, Object], default : undefined },
        weight                        : { type : Number, default : undefined },

         // Configs and properties
        alignSelf                  : { type : String, default : undefined },
        appendTo                   : { type : [HTMLElement, String], default : undefined },
        cls                        : { type : [String, Object], default : undefined },
        columnLines                : { type : Boolean, default : undefined },
        comparingVersionId         : { type : Boolean, default : undefined },
        content                    : { type : String, default : undefined },
        data                       : { type : Array, default : undefined },
        dataset                    : { type : Object, default : undefined },
        disabled                   : { type : Boolean, default : undefined },
        emptyText                  : { type : String, default : undefined },
        enableUndoRedoKeys         : { type : Boolean, default : undefined },
        extraData                  : { type : [String, Number, Boolean, Object], default : undefined },
        flex                       : { type : [Number, String], default : undefined },
        height                     : { type : [Number, String], default : undefined },
        hidden                     : { type : Boolean, default : undefined },
        hideFooters                : { type : Boolean, default : undefined },
        hideHeaders                : { type : Boolean, default : undefined },
        html                       : { type : [String, Function], default : undefined },
        id                         : { type : String, default : undefined },
        insertBefore               : { type : [HTMLElement, String], default : undefined },
        insertFirst                : { type : [HTMLElement, String], default : undefined },
        items                      : { type : [Array, Object], default : undefined },
        layout                     : { type : [Layout, String, Object], default : undefined },
        layoutStyle                : { type : Object, default : undefined },
        longPressTime              : { type : Number, default : undefined },
        margin                     : { type : [Number, String], default : undefined },
        maxHeight                  : { type : [String, Number], default : undefined },
        maximizeOnMobile           : { type : [Number, String], default : undefined },
        maxWidth                   : { type : [String, Number], default : undefined },
        minHeight                  : { type : [String, Number], default : undefined },
        minWidth                   : { type : [String, Number], default : undefined },
        readOnly                   : { type : Boolean, default : undefined },
        record                     : { type : Model, default : undefined },
        rowHeight                  : { type : Number, default : undefined },
        scrollable                 : { type : [Scroller, Boolean, Object], default : undefined },
        showNamedVersionsOnly      : { type : Boolean, default : undefined },
        showUnattachedTransactions : { type : Boolean, default : undefined },
        showVersions               : { type : Boolean, default : undefined },
        store                      : { type : [Store, Object], default : undefined },
        strictRecordMapping        : { type : Boolean, default : undefined },
        title                      : { type : String, default : undefined },
        tools                      : { type : Object, default : undefined },
        tooltip                    : { type : [String, Object], default : undefined },
        transitionDuration         : { type : Number, default : undefined },
        width                      : { type : [Number, String], default : undefined },
        x                          : { type : Number, default : undefined },
        y                          : { type : Number, default : undefined },

         // Properties only
        anchorSize      : { type : Array, default : undefined },
        isSettingValues : { type : Boolean, default : undefined },
        isValid         : { type : Boolean, default : undefined },
        selectedCell    : { type : Location, default : undefined },
        selectedCells   : { type : Array, default : undefined },
        selectedRecord  : { type : Model, default : undefined },
        selectedRecords : { type : Array, default : undefined },
        selectedRows    : { type : Array, default : undefined },
        state           : { type : Object, default : undefined },
        type            : { type : String, default : undefined },
        values          : { type : Object, default : undefined },

         // Events
        onBeforeCancelCellEdit      : { type : Function, default : undefined },
        onBeforeCellDelete          : { type : Function, default : undefined },
        onBeforeCellEditStart       : { type : Function, default : undefined },
        onBeforeClose               : { type : Function, default : undefined },
        onBeforeColumnDragStart     : { type : Function, default : undefined },
        onBeforeColumnDropFinalize  : { type : Function, default : undefined },
        onBeforeCopy                : { type : Function, default : undefined },
        onBeforeDestroy             : { type : Function, default : undefined },
        onBeforeFinishCellEdit      : { type : Function, default : undefined },
        onBeforeHide                : { type : Function, default : undefined },
        onBeforePaste               : { type : Function, default : undefined },
        onBeforePdfExport           : { type : Function, default : undefined },
        onBeforeRenderRow           : { type : Function, default : undefined },
        onBeforeRenderRows          : { type : Function, default : undefined },
        onBeforeSelectionChange     : { type : Function, default : undefined },
        onBeforeSetRecord           : { type : Function, default : undefined },
        onBeforeShow                : { type : Function, default : undefined },
        onBeforeToggleGroup         : { type : Function, default : undefined },
        onBeforeToggleNode          : { type : Function, default : undefined },
        onCancelCellEdit            : { type : Function, default : undefined },
        onCatchAll                  : { type : Function, default : undefined },
        onCellClick                 : { type : Function, default : undefined },
        onCellContextMenu           : { type : Function, default : undefined },
        onCellDblClick              : { type : Function, default : undefined },
        onCellMenuBeforeShow        : { type : Function, default : undefined },
        onCellMenuItem              : { type : Function, default : undefined },
        onCellMenuShow              : { type : Function, default : undefined },
        onCellMenuToggleItem        : { type : Function, default : undefined },
        onCellMouseOut              : { type : Function, default : undefined },
        onCellMouseOver             : { type : Function, default : undefined },
        onCollapseNode              : { type : Function, default : undefined },
        onColumnDrag                : { type : Function, default : undefined },
        onColumnDragStart           : { type : Function, default : undefined },
        onColumnDrop                : { type : Function, default : undefined },
        onCompare                   : { type : Function, default : undefined },
        onContextMenuItem           : { type : Function, default : undefined },
        onContextMenuToggleItem     : { type : Function, default : undefined },
        onCopy                      : { type : Function, default : undefined },
        onDataChange                : { type : Function, default : undefined },
        onDestroy                   : { type : Function, default : undefined },
        onDragSelecting             : { type : Function, default : undefined },
        onExpandNode                : { type : Function, default : undefined },
        onFileDrop                  : { type : Function, default : undefined },
        onFinishCellEdit            : { type : Function, default : undefined },
        onFocusIn                   : { type : Function, default : undefined },
        onFocusOut                  : { type : Function, default : undefined },
        onGridRowAbort              : { type : Function, default : undefined },
        onGridRowBeforeDragStart    : { type : Function, default : undefined },
        onGridRowBeforeDropFinalize : { type : Function, default : undefined },
        onGridRowDrag               : { type : Function, default : undefined },
        onGridRowDragStart          : { type : Function, default : undefined },
        onGridRowDrop               : { type : Function, default : undefined },
        onHeaderMenuBeforeShow      : { type : Function, default : undefined },
        onHeaderMenuItem            : { type : Function, default : undefined },
        onHeaderMenuShow            : { type : Function, default : undefined },
        onHeaderMenuToggleItem      : { type : Function, default : undefined },
        onHide                      : { type : Function, default : undefined },
        onMouseOut                  : { type : Function, default : undefined },
        onMouseOver                 : { type : Function, default : undefined },
        onPaint                     : { type : Function, default : undefined },
        onPaste                     : { type : Function, default : undefined },
        onPdfExport                 : { type : Function, default : undefined },
        onPointerOver               : { type : Function, default : undefined },
        onReadOnly                  : { type : Function, default : undefined },
        onRecompose                 : { type : Function, default : undefined },
        onRenderRow                 : { type : Function, default : undefined },
        onRenderRows                : { type : Function, default : undefined },
        onResize                    : { type : Function, default : undefined },
        onResponsive                : { type : Function, default : undefined },
        onRestore                   : { type : Function, default : undefined },
        onScroll                    : { type : Function, default : undefined },
        onSelectionChange           : { type : Function, default : undefined },
        onSelectionModeChange       : { type : Function, default : undefined },
        onShow                      : { type : Function, default : undefined },
        onSplit                     : { type : Function, default : undefined },
        onSplitterCollapseClick     : { type : Function, default : undefined },
        onSplitterDragEnd           : { type : Function, default : undefined },
        onSplitterDragStart         : { type : Function, default : undefined },
        onStartCellEdit             : { type : Function, default : undefined },
        onStopCompare               : { type : Function, default : undefined },
        onSubGridCollapse           : { type : Function, default : undefined },
        onSubGridExpand             : { type : Function, default : undefined },
        onToggleGroup               : { type : Function, default : undefined },
        onToggleNode                : { type : Function, default : undefined },
        onToolClick                 : { type : Function, default : undefined },
        onUnsplit                   : { type : Function, default : undefined },

         // Features
        cellCopyPasteFeature     : { type : [Object, Boolean, String], default : undefined },
        cellEditFeature          : { type : [Object, Boolean, String], default : undefined },
        cellMenuFeature          : { type : [Object, Boolean, String], default : undefined },
        cellTooltipFeature       : { type : [Object, Boolean, String], default : undefined },
        columnAutoWidthFeature   : { type : [Object, Boolean, String], default : undefined },
        columnDragToolbarFeature : { type : [Object, Boolean, String], default : undefined },
        columnPickerFeature      : { type : [Object, Boolean, String], default : undefined },
        columnRenameFeature      : { type : [Object, Boolean, String], default : undefined },
        columnReorderFeature     : { type : [Object, Boolean, String], default : undefined },
        columnResizeFeature      : { type : [Object, Boolean, String], default : undefined },
        excelExporterFeature     : { type : [Object, Boolean, String], default : undefined },
        fileDropFeature          : { type : [Object, Boolean, String], default : undefined },
        fillHandleFeature        : { type : [Object, Boolean, String], default : undefined },
        filterFeature            : { type : [Object, Boolean, String], default : undefined },
        filterBarFeature         : { type : [Object, Boolean, String], default : undefined },
        groupFeature             : { type : [Object, Boolean, String], default : undefined },
        groupSummaryFeature      : { type : [Object, Boolean, String], default : undefined },
        headerMenuFeature        : { type : [Object, Boolean, String], default : undefined },
        mergeCellsFeature        : { type : [Object, Boolean, String], default : undefined },
        multipageFeature         : { type : [Object, Boolean, String], default : undefined },
        multipageverticalFeature : { type : [Object, Boolean, String], default : undefined },
        pdfExportFeature         : { type : [Object, Boolean, String], default : undefined },
        quickFindFeature         : { type : [Object, Boolean, String], default : undefined },
        regionResizeFeature      : { type : [Object, Boolean, String], default : undefined },
        rowCopyPasteFeature      : { type : [Object, Boolean, String], default : undefined },
        rowExpanderFeature       : { type : [Object, Boolean, String], default : undefined },
        rowReorderFeature        : { type : [Object, Boolean, String], default : undefined },
        searchFeature            : { type : [Object, Boolean, String], default : undefined },
        singlepageFeature        : { type : [Object, Boolean, String], default : undefined },
        sortFeature              : { type : [Object, Boolean, String], default : undefined },
        splitFeature             : { type : [Object, Boolean, String], default : undefined },
        stickyCellsFeature       : { type : [Object, Boolean, String], default : undefined },
        stripeFeature            : { type : [Object, Boolean, String], default : undefined },
        summaryFeature           : { type : [Object, Boolean, String], default : undefined },
        treeFeature              : { type : [Object, Boolean, String], default : undefined },
        treeGroupFeature         : { type : [Object, Boolean, String], default : undefined },

    },

    emits : [
        'beforecancelcelledit',
        'beforecelldelete',
        'beforecelleditstart',
        'beforeclose',
        'beforecolumndragstart',
        'beforecolumndropfinalize',
        'beforecopy',
        'beforedestroy',
        'beforefinishcelledit',
        'beforehide',
        'beforepaste',
        'beforepdfexport',
        'beforerenderrow',
        'beforerenderrows',
        'beforeselectionchange',
        'beforesetrecord',
        'beforeshow',
        'beforetogglegroup',
        'beforetogglenode',
        'cancelcelledit',
        'catchall',
        'cellclick',
        'cellcontextmenu',
        'celldblclick',
        'cellmenubeforeshow',
        'cellmenuitem',
        'cellmenushow',
        'cellmenutoggleitem',
        'cellmouseout',
        'cellmouseover',
        'collapsenode',
        'columndrag',
        'columndragstart',
        'columndrop',
        'compare',
        'contextmenuitem',
        'contextmenutoggleitem',
        'copy',
        'datachange',
        'destroy',
        'dragselecting',
        'expandnode',
        'filedrop',
        'finishcelledit',
        'focusin',
        'focusout',
        'gridrowabort',
        'gridrowbeforedragstart',
        'gridrowbeforedropfinalize',
        'gridrowdrag',
        'gridrowdragstart',
        'gridrowdrop',
        'headermenubeforeshow',
        'headermenuitem',
        'headermenushow',
        'headermenutoggleitem',
        'hide',
        'mouseout',
        'mouseover',
        'paint',
        'paste',
        'pdfexport',
        'pointerover',
        'recompose',
        'renderrow',
        'renderrows',
        'resize',
        'responsive',
        'restore',
        'scroll',
        'selectionchange',
        'selectionmodechange',
        'show',
        'split',
        'splittercollapseclick',
        'splitterdragend',
        'splitterdragstart',
        'startcelledit',
        'stopcompare',
        'subgridcollapse',
        'subgridexpand',
        'togglegroup',
        'togglenode',
        'toolclick',
        'unsplit'
    ],

    data : () => {
        return {
            instanceClass : VersionGrid,
            instanceName : 'VersionGrid',

            configNames : [
                'adopt',
                'align',
                'allowOver',
                'anchor',
                'anchorToTarget',
                'animateRemovingRows',
                'ariaDescription',
                'ariaLabel',
                'autoClose',
                'autoHeight',
                'autoShow',
                'autoUpdateRecord',
                'bbar',
                'bodyCls',
                'bubbleEvents',
                'callOnFunctions',
                'centered',
                'closable',
                'closeAction',
                'collapsed',
                'collapsible',
                'columns',
                'config',
                'constrainTo',
                'contentElementCls',
                'contextMenuTriggerEvent',
                'dateFormat',
                'defaultBindProperty',
                'defaultFocus',
                'defaultRegion',
                'defaults',
                'destroyStore',
                'disableGridRowModelWarning',
                'dismissDelay',
                'dock',
                'draggable',
                'enableSticky',
                'enableTextSelection',
                'features',
                'fillLastColumn',
                'fixedRowHeight',
                'floating',
                'focusOnToFront',
                'footer',
                'forElement',
                'forSelector',
                'fullRowRefresh',
                'getHtml',
                'getRowHeight',
                'header',
                'hideAnimation',
                'hideDelay',
                'hideHorizontalScrollbar',
                'hideOnDelegateChange',
                'hideWhenEmpty',
                'hoverDelay',
                'htmlCls',
                'ignoreParentReadOnly',
                'itemCls',
                'keyMap',
                'lazyItems',
                'listeners',
                'loadingMsg',
                'loadMask',
                'loadMaskDefaults',
                'loadMaskError',
                'localeClass',
                'localizable',
                'localizableProperties',
                'maskDefaults',
                'masked',
                'maximizable',
                'maximized',
                'modal',
                'monitorResize',
                'mouseOffsetX',
                'mouseOffsetY',
                'namedItems',
                'owner',
                'plugins',
                'positioned',
                'preserveFocusOnDatasetChange',
                'preserveScrollOnDatasetChange',
                'preventTooltipOnTouch',
                'project',
                'relayStoreEvents',
                'resizeToFitIncludesHeader',
                'responsiveLevels',
                'ripple',
                'rootElement',
                'scrollAction',
                'scrollerClass',
                'scrollManager',
                'selectionMode',
                'showAnimation',
                'showDirty',
                'showOnClick',
                'showOnHover',
                'showTooltipWhenDisabled',
                'stateful',
                'statefulEvents',
                'stateId',
                'stateProvider',
                'strips',
                'subGridConfigs',
                'syncMask',
                'tab',
                'tag',
                'tbar',
                'textAlign',
                'textContent',
                'trackMouse',
                'trapFocus',
                'ui',
                'weight'
            ],

            propertyConfigNames : [
                'alignSelf',
                'appendTo',
                'cls',
                'columnLines',
                'comparingVersionId',
                'content',
                'data',
                'dataset',
                'disabled',
                'emptyText',
                'enableUndoRedoKeys',
                'extraData',
                'flex',
                'height',
                'hidden',
                'hideFooters',
                'hideHeaders',
                'html',
                'id',
                'insertBefore',
                'insertFirst',
                'items',
                'layout',
                'layoutStyle',
                'longPressTime',
                'margin',
                'maxHeight',
                'maximizeOnMobile',
                'maxWidth',
                'minHeight',
                'minWidth',
                'onBeforeCancelCellEdit',
                'onBeforeCellDelete',
                'onBeforeCellEditStart',
                'onBeforeClose',
                'onBeforeColumnDragStart',
                'onBeforeColumnDropFinalize',
                'onBeforeCopy',
                'onBeforeDestroy',
                'onBeforeFinishCellEdit',
                'onBeforeHide',
                'onBeforePaste',
                'onBeforePdfExport',
                'onBeforeRenderRow',
                'onBeforeRenderRows',
                'onBeforeSelectionChange',
                'onBeforeSetRecord',
                'onBeforeShow',
                'onBeforeToggleGroup',
                'onBeforeToggleNode',
                'onCancelCellEdit',
                'onCatchAll',
                'onCellClick',
                'onCellContextMenu',
                'onCellDblClick',
                'onCellMenuBeforeShow',
                'onCellMenuItem',
                'onCellMenuShow',
                'onCellMenuToggleItem',
                'onCellMouseOut',
                'onCellMouseOver',
                'onCollapseNode',
                'onColumnDrag',
                'onColumnDragStart',
                'onColumnDrop',
                'onCompare',
                'onContextMenuItem',
                'onContextMenuToggleItem',
                'onCopy',
                'onDataChange',
                'onDestroy',
                'onDragSelecting',
                'onExpandNode',
                'onFileDrop',
                'onFinishCellEdit',
                'onFocusIn',
                'onFocusOut',
                'onGridRowAbort',
                'onGridRowBeforeDragStart',
                'onGridRowBeforeDropFinalize',
                'onGridRowDrag',
                'onGridRowDragStart',
                'onGridRowDrop',
                'onHeaderMenuBeforeShow',
                'onHeaderMenuItem',
                'onHeaderMenuShow',
                'onHeaderMenuToggleItem',
                'onHide',
                'onMouseOut',
                'onMouseOver',
                'onPaint',
                'onPaste',
                'onPdfExport',
                'onPointerOver',
                'onReadOnly',
                'onRecompose',
                'onRenderRow',
                'onRenderRows',
                'onResize',
                'onResponsive',
                'onRestore',
                'onScroll',
                'onSelectionChange',
                'onSelectionModeChange',
                'onShow',
                'onSplit',
                'onSplitterCollapseClick',
                'onSplitterDragEnd',
                'onSplitterDragStart',
                'onStartCellEdit',
                'onStopCompare',
                'onSubGridCollapse',
                'onSubGridExpand',
                'onToggleGroup',
                'onToggleNode',
                'onToolClick',
                'onUnsplit',
                'readOnly',
                'record',
                'rowHeight',
                'scrollable',
                'showNamedVersionsOnly',
                'showUnattachedTransactions',
                'showVersions',
                'store',
                'strictRecordMapping',
                'title',
                'tools',
                'tooltip',
                'transitionDuration',
                'width',
                'x',
                'y'
            ],

            propertyNames : [
                'anchorSize',
                'isSettingValues',
                'isValid',
                'selectedCell',
                'selectedCells',
                'selectedRecord',
                'selectedRecords',
                'selectedRows',
                'state',
                'type',
                'values'
            ],

            eventNames : [
                'beforeCancelCellEdit',
                'beforeCellDelete',
                'beforeCellEditStart',
                'beforeClose',
                'beforeColumnDragStart',
                'beforeColumnDropFinalize',
                'beforeCopy',
                'beforeDestroy',
                'beforeFinishCellEdit',
                'beforeHide',
                'beforePaste',
                'beforePdfExport',
                'beforeRenderRow',
                'beforeRenderRows',
                'beforeSelectionChange',
                'beforeSetRecord',
                'beforeShow',
                'beforeToggleGroup',
                'beforeToggleNode',
                'cancelCellEdit',
                'catchAll',
                'cellClick',
                'cellContextMenu',
                'cellDblClick',
                'cellMenuBeforeShow',
                'cellMenuItem',
                'cellMenuShow',
                'cellMenuToggleItem',
                'cellMouseOut',
                'cellMouseOver',
                'collapseNode',
                'columnDrag',
                'columnDragStart',
                'columnDrop',
                'compare',
                'contextMenuItem',
                'contextMenuToggleItem',
                'copy',
                'dataChange',
                'destroy',
                'dragSelecting',
                'expandNode',
                'fileDrop',
                'finishCellEdit',
                'focusIn',
                'focusOut',
                'gridRowAbort',
                'gridRowBeforeDragStart',
                'gridRowBeforeDropFinalize',
                'gridRowDrag',
                'gridRowDragStart',
                'gridRowDrop',
                'headerMenuBeforeShow',
                'headerMenuItem',
                'headerMenuShow',
                'headerMenuToggleItem',
                'hide',
                'mouseOut',
                'mouseOver',
                'paint',
                'paste',
                'pdfExport',
                'pointerOver',
                'recompose',
                'renderRow',
                'renderRows',
                'resize',
                'responsive',
                'restore',
                'scroll',
                'selectionChange',
                'selectionModeChange',
                'show',
                'split',
                'splitterCollapseClick',
                'splitterDragEnd',
                'splitterDragStart',
                'startCellEdit',
                'stopCompare',
                'subGridCollapse',
                'subGridExpand',
                'toggleGroup',
                'toggleNode',
                'toolClick',
                'unsplit'
            ]
        };
    },

    setup(props, { emit }) {
        const instance = {};
        const refElement = ref(null);

        // Storage for teleports (in-cell Vue component instances)
        // automatically renderer by template
        const teleports = ref(new Map());

        const { createWidget, relayStores, watchProps } = useWrapperHelper();
        const { processCellContent, hasFrameworkRenderer } = useWrapperHelperVue3();

        // Provide teleports for processCellContent
        provide('teleports', teleports);

        onMounted(() => {
            const
                me = getCurrentInstance(),
                uncapitalize = str => str.charAt(0).toLowerCase() + str.slice(1),
                eventName = str => uncapitalize(str.slice(2)),
                // Collect event listeners from me.props where they are `on` functions
                listeners = Object.keys(me.props)
                    .filter(prop => typeof me.props[prop] === 'function' && prop.startsWith('on') && prop.length > 2)
                    .map(eventName);

            instance.value = createWidget({
                me,
                props   : me.props,
                data    : me.data,
                listeners,
                emit,
                element : refElement.value
            });

            const watcher = (prop, newValue) => watch(() => me.props[prop], newValue);
            watchProps(me, instance.value, me.props, me.data, watcher);
        });

        onBeforeUnmount(() => {
            if (instance.value) {
                instance.value.destroy();
            }
        });

        return { instance, refElement, teleports };
    }
};
</script>
